
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes, faCog } from '@fortawesome/free-solid-svg-icons'

import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import { useMatomo } from '@jonkoops/matomo-tracker-react'

import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover';
import Tooltip from 'react-bootstrap/Tooltip'

import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import Select from 'react-select'
import {
  Link,
  useParams,
} from "react-router-dom"
import { toast } from 'react-toastify'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  FiltersBox,
} from '$src/components'
import {
  BanksCtx,
} from '$src/components/banks'
import {
  PeriodsCtx,
} from '$src/components/periods'
import {
  ActionsVerticalMenu,
  PdfModal,
  ReportsCtx,
} from '$src/components/reports'


/**
 * UnauthorizedContactsModal
**/
const UnauthorizedContactsModal = (props) => {

  const {
    unauthorizedContactsModalOpen, setUnauthorizedContactsModalOpen,
  } = useContext(ReportsCtx)

  return <Modal
      className="UnauthorizedContactsModal BaseModal "
      isOpen={unauthorizedContactsModalOpen}
      onRequestClose={ () => setUnauthorizedContactsModalOpen(false) }
      overlayClassName="UnauthorizedContactsModalOverlay"
    >
      <div className='header'>
        <h5>Unauthorized</h5>
      </div>
      <div className='C1 m-3'>
        <p>Sorry, you don't have authorizaton to view this data.</p>
        <p>Please contact the <a href="mailto:info@fedfis.com">Sales</a> team to upgrade your account.</p>
      </div>
      <div className='actions'>
        <div className='left'></div>
        <div className='right'>
          <button onClick={() => setUnauthorizedContactsModalOpen(false) } >Close</button>
        </div>
      </div>
    </Modal>
}
export default UnauthorizedContactsModal
